import React, { useState, useEffect } from "react";
import Navbar from "../components/common/Navbar";
import HeroSlider from "../components/sliders/HeroSlider";
import sectiondata from "../store/store";
import { Link } from "react-router-dom";
import { FiChevronRight } from "react-icons/fi";
import GetInTouchButton from "../components/about/GetInTouchButton";
import know from "../assets/images/KnowAboutUs.png"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlassArrowRight  } from '@fortawesome/free-solid-svg-icons';
import "./Home.css";


const Disclaimer = ({ onAgree }) => (
  <div className="disclaimer-container">
    <p style={{textAlign:"justify"}}>
      The contents of this website are not directed towards residents of the
      United States of America or a resident of a jurisdiction, the laws of
      which impose prohibition on soliciting the advisory business in that
      jurisdiction without going through the registration requirements and/or
      prohibit the use of any information contained in this website.
    </p>
    <button onClick={onAgree}>Agree and Continue</button>
  </div>
);

export default function Home() {
  const [isAgreed, setIsAgreed] = useState(localStorage.getItem("isAgreed") === "true");
  const [isTableOpen, setIsTableOpen] = useState(true);
  const [isVigilanceOpen, setIsVigilanceOpen] = useState(true);

  useEffect(() => {
    const agreedStatus = localStorage.getItem("isAgreed") === "true";
    setIsAgreed(agreedStatus);
  }, []);

  const handleAgree = () => {
    localStorage.setItem("isAgreed", "true");
    setIsAgreed(true);
    // Show the table when agreed
    setIsTableOpen(true);
  };

  const handleCloseTable = () => {
    setIsTableOpen(false);
  };

  const handleCloseVigilance = () => {
    setIsVigilanceOpen(false);
  };
  const [isHovered, setIsHovered] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const handleClick = () => {
    setIsClicked(!isClicked);
  };

  // Responsive styles for mobile
  const getResponsiveStyles = () => {
    const isMobile = window.innerWidth <= 768;
    return {
      vigilanceContainer: {
        position: 'absolute', 
        top: isMobile ? '200px' : '120px', 
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9999,
        backgroundColor: '#c39239',
        padding: isMobile ? '10px 15px' : '15px 20px',
        borderRadius: '5px',
        width: isMobile ? '90%' : '50%',
        minWidth: isMobile ? '250px' : '280px',
        maxWidth: isMobile ? '350px' : '600px'
      },
      vigilanceText: {
        color: 'white',
        fontSize: isMobile ? '10px' : 'clamp(10px, 2vw, 12px)',
        lineHeight: '1.4',
        fontWeight: 'bold',
        textAlign: 'center'
      },
      closeButton: {
        position: 'absolute',
        top: '5px',
        right: '10px',
        background: 'none',
        border: 'none',
        color: 'white',
        fontSize: '18px',
        cursor: 'pointer',
        fontWeight: 'bold',
        lineHeight: '1',
        padding: '0',
        width: '20px',
        height: '20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }
    };
  };

  const styles = getResponsiveStyles();
  return (
    <>
      {/* Display content only if agreed */}
      {isAgreed && (
        <>
          {/* Hero Slider */}
          <header className="header-area">
            <Navbar />
          </header>
          {/* Main Content */}
          <main id="main-content">
            {/* Hero Slider - Main visual content */}
            <div
              role="region"
              aria-roledescription="carousel"
              aria-label="Main carousel, 7 slides"
              style={{ position: 'relative' }}
            >
              <HeroSlider slideItems={sectiondata.Sliders.heroSlider1} />
            </div>

            {/* Add the rest of your components here */}
            {/* ... other components ... */}
              {/* Other components */}
            <div className="get-in-touch-container">
              <GetInTouchButton />
            </div>

       <div className="know">
      <Link className="know-link"
        to={"/about"}
        aria-label="Know more about Agreya Capital"
        title="Know more about Agreya Capital"
      >
          <FontAwesomeIcon icon={faMagnifyingGlassArrowRight} className="know-icon" />
      </Link>
      <span className="know-title">Know About Us</span>
    </div>


          {/* Table display */}
        {isTableOpen && (
          <div id="bottom-table">
            <i
              className="fa fa-times-circle"
              onClick={handleCloseTable}
              role="button"
              aria-label="Close"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  handleCloseTable();
                }
              }}
            >
              &times;
            </i>
            <div className="table-responsive">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th colSpan="5" className="text-center">Display of complaints data for advisory services-Aug'26</th>
                  </tr>
                  <tr>
                    <th>At the beginning of the month</th>
                    <th>Received during the month</th>
                    <th>Resolved during the month</th>
                    <th>Pending at the end of the month</th>
                    <th>Reasons for pendency</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>0</td>
                    <td>0</td>
                    <td>0</td>
                    <td>0</td>
                    <td>0</td>
                  </tr>
                </tbody>
              </table>
              </div>
            </div>
          )}
          </main>
        </>
      )}
        {/* <header className="header-area">
            <Navbar />
          </header> */}

        {/* Vigilance Pledge Button - Above complaints table
        {isVigilanceOpen && (
          <div className="vigilance-pledge-container" style={styles.vigilanceContainer}>
            <button 
              style={styles.closeButton}
              onClick={handleCloseVigilance}
              // title="Close"
            >
              ×
            </button>
            <a target="_blank" href="https://pledge.cvc.nic.in/" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
              <div style={styles.vigilanceText}>
                "सतर्कता: हमारी साझा जिम्मेदारी" - "Vigilance: Our Shared Responsibility"<br />
                Vigilance Pledge
              </div>
            </a>
          </div>
        )} */}

      {/* Disclaimer overlay */}
      {!isAgreed && <Disclaimer onAgree={handleAgree} />}
    </>
  );
}
